import React, { useState, useEffect } from "react";
import TopBar from "../topbar/Top-Bar";
import SideBar from "../sidebar/sidebar";
import { Helmet } from "react-helmet-async";
import PersonalInfoPage1 from "./pages/personal-info-1";
import PersonalInfoPage2 from "./pages/personal-info-2";
import PersonalInfoPage3 from "./pages/personal-info-3";
import PersonalInfoPage4 from "./pages/personal-info-4";
import ProfileCreationWelcome from "./pages/welcome";
import Experience1 from "./pages/experience-1";
import Experience2 from "./pages/experience-2";
import Experience3 from "./pages/experience-3";
import Experience4 from "./pages/experience-4";
import Experience5 from "./pages/experience-5";
import Experience6 from "./pages/experience-6";
import Experience7 from "./pages/experience-7";
import Skill1 from "./pages/skills-1";
import Skill1a from "./pages/skills-1a";
import Skill2 from "./pages/skills-2";
import Cert from "./pages/cert-1";
import Skill3 from "./pages/skills-3";
import Skill4 from "./pages/skills-4";
import Skill5 from "./pages/skills-5";
import Education1 from "./pages/education-1";
import Education2 from "./pages/education-2";
import Education3 from "./pages/education-3";
import Education4 from "./pages/education-4";
import Education5 from "./pages/education-5";
import Education6 from "./pages/education-6";
import Summary1 from "./pages/summary-1";
import Summary2 from "./pages/summary-2";
import SelcectTemplate from "./pages/selectResume";
import Closing from "./pages/closingPage";
import PreviewDetails from "./pages/preview"
import {
  resume_step_sub_function,
  resume_step_add_function,
  resume_step_jump_function,
  save_personal_details,
  save_secret,
  generate_my_cv,
  returnHome,
  Professional_summary,
  dispatchEducation,
  currentEducation,
  dispatchLanguage,
  dispatchPskills,
  dispatchSkills,
  current_skills,
  dispatchActivites,
  currentExperience,
  personal_information,
  dispatchT_Language,
  cert_function
} from "../../Redux/ActionCreator";
import { useDispatch, useSelector } from "react-redux";
import { saveIntoServerCache, getOneFromServerCache, getMultipleKeysFromCache } from "../../utils/saveIntoCache";
import SelectLanguage from "../common/resumeLangSelection/selectLanguage";
import { createPortal } from "react-dom";
import BottonBar from "../bottom_bar";

export default function ProfileCreation() {
  const dispatch = useDispatch();
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  // const [step, setStep] = useState(1);
  let step = useSelector(step => step.resumeStep);
  const secret = useSelector(e => e.secret);  
  const sidebar = useSelector(e => e.sidebarOpen.message);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const extraction = useSelector(e => e.existingCV);
  const profile = useSelector(e => e.profile);

  console.log("step before routing", step);
  useEffect(() => {
    if (extraction.message !== null && profile.message == null) {
      setStep(27);
    } else {
      if (step !== 0) {
        if (profile.message?.CompletionPercentage <= 95) {
          console.log("callsedss 😪💘");
          getAllNecessaryKeysFromCache();
        }
        setStep(step); // uploading of resumes only
      } else {
        console.log("callsedss 😪")
        getAllNecessaryKeysFromCache();
      }
    }
    
  }, [])

  const [ rerender, setRerender ] = useState("")

  useEffect(() => {
    if (flowLanguage == null) {
      // try to get from server if there is
      let Language = getOneFromServerCache("Language");
        Language.then(resp => resp.json())
        .then(resp => {
          // console.log("Language", resp.data);
          if (resp.success == true) {
            if (resp.data == null) {
              setShowLanguageModal(true)
            } else {
              let lan = JSON.parse(resp.data);
              dispatch(dispatchT_Language(lan));
              setRerender(lan)
              setShowLanguageModal(false);
            }
          } else if (resp.success === false && resp.message == "Unauthorized") {
            dispatch(returnHome(resp.status));
          }
        }).catch(err => {
          // console.log("Language getting error", err);
        });
    } else {
      // console.log("re-render")
      // setRerender(flowLanguage);
    }
    // if (showLanguageModal !== true) {
    //   setShowLanguageModal(true);
    // }
  }, [flowLanguage]);

  let getAllNecessaryKeysFromCache = async () => {
    try {
      let keysToGet = [
        "step",
        "personalInfo", 
        "current_experience", 
        "experience", 
        "current_skills", 
        "technicalSkills", 
        "personalSkills", 
        "education", 
        "current_education", 
        "language", 
        "summary",
        "cert"
      ];

      let allKeyData = await getMultipleKeysFromCache(keysToGet);
      let data = await allKeyData.json();
      
      console.log("data", data);
      if (data.success == true) {
        let cachedData = data.data;
        console.log("cached date", cachedData);
        // no need to parse
        // Dispatch each data field to the corresponding Redux store
        if ((profile.message !== null && profile.message?.CompletionPercentage >= 95) || profile.message == null) {
          dispatch(personal_information(cachedData.personalInfo || null));
          dispatch(dispatchActivites(cachedData.experience || null));
          dispatch(currentExperience(cachedData.current_experience || null));
          dispatch(current_skills(cachedData.current_skills || null));
          dispatch(dispatchSkills(cachedData.technicalSkills || null));
          dispatch(dispatchPskills(cachedData.personalSkills || null));
          dispatch(dispatchLanguage(cachedData.language || null));
          dispatch(currentEducation(cachedData.current_education || null));
          dispatch(dispatchEducation(cachedData.education || null));
          dispatch(Professional_summary(cachedData.summary || null));
          dispatch(cert_function(cachedData.cert || null))
          
          // Restore last step from cache
          if (cachedData.step) {
            dispatch(resume_step_jump_function(cachedData.step));
          }
        } else if (profile.message !== null && profile.message?.CompletionPercentage < 95) {
          let profileInfo = profile.message;
          if (profileInfo !== null) {
            let personalInformation = {
              Firstname: profileInfo?.FirstName,
              LastName: profileInfo?.LastName,
              Address: profileInfo?.Address,
              Phone_number: profileInfo?.Phone_number,
              Email: profileInfo?.Email,
              Secret: secret.secret,
              JobInterests: profileInfo.JobInterests?.map(e => (e?.value))
            };
            dispatch(personal_information(cachedData.personalInfo || personalInformation || null));
            dispatch(dispatchActivites(cachedData.experience || profileInfo.Experience || null));
            dispatch(currentExperience(cachedData.current_experience || profileInfo.Experience[0] || null));
            dispatch(current_skills(cachedData.current_skills || profileInfo.Skills || null));
            dispatch(dispatchSkills(cachedData.technicalSkills?.length !== 0 && cachedData.technicalSkills !== undefined ? cachedData.technicalSkills : profileInfo.Skills || null));
            dispatch(dispatchPskills(cachedData.personalSkills?.length !== 0 && cachedData.technicalSkills !== undefined ? cachedData.personalSkills : profileInfo.Soft_skills || null));
            dispatch(dispatchLanguage(cachedData.language || profileInfo.Language || null));
            dispatch(currentEducation(cachedData.current_education || profileInfo.Education[0] || null));
            dispatch(dispatchEducation(cachedData.education || profileInfo.Education || null));
            dispatch(Professional_summary(cachedData.summary || profileInfo.About || null));
            dispatch(cert_function(cachedData.cert || profileInfo.certification || null));
          }
        }
      } else {
        console.log("failed to get values", data);
      }
    } catch (error) {
      console.log("Error getting all values from cache", error);
    }
  }
  // Function to move to the next step
  const nextStep = (arg) => {
    // save step to cache
    saveIntoServerCache("step", step + 1);
    // dispatch(resume_step_add_function());
    dispatch(resume_step_jump_function(step + 1))
  };

  const setStep = (toStep) => {
    dispatch(resume_step_jump_function(toStep));
  }

  // Function to go back to the previous step
  const prevStep = () => {
    if (step > 0) {
      dispatch(resume_step_sub_function());
    }
  };

  console.log("step", step);

  const [ studying, setStudying ] = useState(false);
  
  const [ workingThere, setWorkingThere ] = useState(false);

  // console.log("showLanguageModal", showLanguageModal)
  let showModal = showLanguageModal ? createPortal(
    <div className="top-0 left-0 fixed bottom-0 right-0 z-10 h-screen flex justify-center items-center md:bg-black md:bg-opacity-70 backdrop-blur-[2px] sm:bg-white xsm:bg-white">
      <SelectLanguage handleClick={() => setShowLanguageModal(false)} back="/generateCV" />
    </div>, document.getElementById("Language")
  ) : null;
  

  return (
    <>
      <Helmet>
        <title className="notranslate">Moil | Create Your Resume</title>
        <meta
          name="description"
          content="Build your professional resume with Moil's easy-to-use resume creation form. Showcase your skills, experience, and qualifications to potential employers."
          className="notranslate"
        />
        <meta property="og:title" content="Moil | Create Your Resume" 
          className="notranslate" />
        <meta
          property="og:description"
          content="Build your professional resume with Moil's easy-to-use resume creation form. Showcase your skills, experience, and qualifications to potential employers."        
          className="notranslate"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/daudj5isi/image/upload/v1696694006/images/Moil%20Company.png"
          className="notranslate"
        />
      </Helmet>
    <div className={profile.message !== null && profile.message?.CompletionPercentage >= 95 ? `grid grid-co md:grid-cols-smdash ${sidebar ? 'cont:grid-cols-dash' : ''} grid-rows-dash` : "w-full"}> {/* {`grid grid-co md:grid-cols-smdash ${sidebar ? 'cont:grid-cols-dash' : ''} grid-rows-dash`} */}
      <TopBar topBarShowMenu={true} />
      { profile.message !== null && profile.message?.CompletionPercentage >= 95 && (
        <div>
          <SideBar />
        </div>
      )}

      <div className="flex-grow flex items-center w-full overflow-x-hidden">
        {step === 0 && <ProfileCreationWelcome nextStep={nextStep} />}
        {step === 1 && <PersonalInfoPage1 nextStep={nextStep} prevStep={prevStep} rerender={rerender} />}
        {step === 2 && <PersonalInfoPage2 nextStep={nextStep} prevStep={prevStep} />}
        {step === 3 && <PersonalInfoPage3 nextStep={nextStep} prevStep={prevStep} />}
        {step === 4 && <PersonalInfoPage4 nextStep={nextStep} prevStep={prevStep} setStep={setStep} />}
        {step === 5 && <Experience1 nextStep={nextStep} prevStep={prevStep} setStep={setStep} />}
        {step === 6 && <Experience2 nextStep={nextStep} prevStep={prevStep} />}
        {step === 7 && <Experience3 nextStep={nextStep} prevStep={prevStep} setWorkingThere={setWorkingThere} />}
        {step === 8 && <Experience4 nextStep={nextStep} prevStep={prevStep} workingThere={workingThere} />}
        {step === 9 && <Experience5 nextStep={nextStep} prevStep={prevStep} />}
        {step === 10 && <Experience6 nextStep={nextStep} prevStep={prevStep} setStep={setStep} />}
        {step === 11 && <Experience7 nextStep={nextStep} prevStep={prevStep} setStep={setStep}/>}
        {step === 12 && <Skill1 nextStep={nextStep} prevStep={prevStep}  />}
        {step === 13 && <Skill1a nextStep={nextStep} prevStep={prevStep}  />}
        {step === 14 && <Skill2 nextStep={nextStep} prevStep={prevStep} setStep={setStep} />}
        {step === 15 && <Skill3 nextStep={nextStep} prevStep={prevStep}  />}
        {step === 16 && <Skill4 nextStep={nextStep} prevStep={prevStep}  />}
        {step === 17 && <Skill5 nextStep={nextStep} prevStep={prevStep}  />}
        {step === 18 && <Education1 nextStep={nextStep} prevStep={prevStep} setStep={setStep}  />}
        {step === 19 && <Education2 nextStep={nextStep} prevStep={prevStep} setStudying={setStudying} />}
        {step === 20 && <Education3 nextStep={nextStep} prevStep={prevStep} studying={studying} setStep={setStep} />}
        {step === 21 && <Education4 nextStep={nextStep} prevStep={prevStep} setStep={setStep} />}
        {step === 22 && <Education5 nextStep={nextStep} prevStep={prevStep} setStep={setStep}  />}
        {step === 23 && <Education6 nextStep={nextStep} prevStep={prevStep} setStep={setStep}  />}
        {step === 24 && <Cert nextStep={nextStep} prevStep={prevStep} setStep={setStep}  />}
        {step === 25 && <Summary1 nextStep={nextStep} prevStep={prevStep} setStep={setStep} />}
        {step === 26 && <Summary2 nextStep={nextStep} prevStep={prevStep}  />}
        {step == 27 && <PreviewDetails nextStep={nextStep} prevStep={prevStep} setStep={setStep} />}
        {step == 28 && <SelcectTemplate nextStep={nextStep} prevStep={prevStep} />}
        {step == 29 && <Closing />}
      </div>
    </div>        
    {sidebar && profile.message?.CompletionPercentage >= 95 && (
      <BottonBar />
    )}
    {showModal}
    </>
  );
}
